import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MobileTailwind from "./MobileTailwind";
import SubHeader from "./components/SubHeader";

const ChevronDown = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path d="M6 9l6 6 6-6" stroke="#8F9098" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const DISHES = ["Thecha Paratha", "Paneer Tikka", "Chicken Curry", "Mutton Fry"];

const Field = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <div className="flex flex-col gap-2 flex-1 min-w-0">
    <span className="font-opensans text-[14px] text-[#111]">{label}</span>
    {children}
  </div>
);

const AmountBadge = ({ label, value, onClick }: { label: string; value: string; onClick?: () => void }) => (

  <button
    type="button"
    onClick={onClick}
    className="w-full rounded-[6px] h-[87px] flex flex-col items-center justify-center gap-1 border-0"
    style={{ backgroundColor: "#F15A29" }}
  >
    <p className="font-opensans text-[16px] text-white">{label}</p>
    <p className="font-sansation font-bold text-[24px] text-white">{value}</p>
  </button>
);

const SplitBill = () => {
  const navigate = useNavigate();
  const { tableNo = "T1" } = useParams<{ tableNo: string }>();
  const [totalAmount, setTotalAmount] = useState("");
  const [guests, setGuests] = useState("");
  const [dishGuests, setDishGuests] = useState("");
  const [dish, setDish] = useState("");
  const [dishOpen, setDishOpen] = useState(false);

  const perPerson = useMemo(() => {
    const t = parseFloat(totalAmount);
    const g = parseInt(guests, 10);
    if (!t || !g) return 0;
    return Math.round(t / g);
  }, [totalAmount, guests]);

  const splitOf = useMemo(() => {
    const g = parseInt(dishGuests, 10);
    if (!g || !dish) return 0;
    return 120 * g;
  }, [dishGuests, dish]);

  return (
    <>
      <MobileTailwind />
      <div id="mobile-root" className="min-h-screen w-full bg-black flex justify-center">
        <div className="relative w-full min-h-screen overflow-x-hidden" style={{ backgroundColor: "#F4F4F5" }} >
          {/* Header */}
          <SubHeader title="Split Bill" />

          <div className="px-3 pt-4 pb-[120px] flex flex-col gap-4">
            
            {/* Row 1: Total + Guests */}
            <div className="flex gap-3">
              <Field label="Total Amount">
                <input
                  type="text"
                  inputMode="decimal"
                  value={totalAmount}
                  onChange={(e) => setTotalAmount(e.target.value)}
                  placeholder="Total Amount"
                  className="w-full h-[47px] rounded-[6px] border bg-white px-4 font-opensans text-[14px] text-[#111] outline-none placeholder:text-[#8F9098]"
                  style={{ borderColor: "#C5C6CC" }}
                />
              </Field>
              <Field label="Number Of Guest">
                <input
                  type="text"
                  inputMode="numeric"
                  value={guests}
                  onChange={(e) => setGuests(e.target.value)}
                  placeholder="Enter guest"
                  className="w-full h-[47px] rounded-[6px] border bg-white px-4 font-opensans text-[14px] text-[#111] outline-none placeholder:text-[#8F9098]"
                  style={{ borderColor: "#C5C6CC" }}
                />
              </Field>
            </div>

            <AmountBadge
              label="Amount Per Person"
              value={`₹${perPerson || 540}`}
            />

            {/* OR divider */}
            <div className="flex items-center gap-2">
              <div className="flex-1 h-px bg-[#C5C6CC]" />
              <span className="font-sansation text-[12px] text-[#111]">OR</span>
              <div className="flex-1 h-px bg-[#C5C6CC]" />
            </div>

            {/* Row 2: Split By Dish + Guests */}
            <div className="flex gap-3">
              <Field label="Split By Dish">
                <div className="relative">
                  <button
                    type="button"
                    onClick={() => setDishOpen((o) => !o)}
                    className="w-full h-[47px] rounded-[6px] border bg-white px-4 font-opensans text-[14px] text-left outline-none flex items-center justify-between"
                    style={{
                      borderColor: "#C5C6CC",
                      color: dish ? "#111" : "#8F9098",
                    }}
                  >
                    <span className="truncate">{dish || "Dish Name"}</span>
                    <ChevronDown />
                  </button>
                  {dishOpen && (
                    <ul className="absolute z-10 top-[52px] left-0 right-0 bg-white border rounded-[10px] shadow-[0_4px_20px_rgba(0,0,0,0.12)] overflow-hidden" style={{ borderColor: "#C5C6CC" }} >
                      {DISHES.map((d) => (
                        <li key={d}>
                          <button
                            type="button"
                            onClick={() => {
                              setDish(d);
                              setDishOpen(false);
                            }}
                            className="w-full text-left px-4 py-2 font-opensans text-[14px] text-[#111] hover:bg-[#F4F4F5] bg-white border-0"
                          >
                            {d}
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </Field>
              <Field label="Number Of Guest">
                <input
                  type="text"
                  inputMode="numeric"
                  value={dishGuests}
                  onChange={(e) => setDishGuests(e.target.value)}
                  placeholder="Enter guest"
                  className="w-full h-[47px] rounded-[6px] border bg-white px-4 font-opensans text-[14px] text-[#111] outline-none placeholder:text-[#8F9098]"
                  style={{ borderColor: "#C5C6CC" }}
                />
              </Field>
            </div>

            <AmountBadge
              label="Payment Split Of"
              value={`₹${splitOf || 540}`}
              onClick={() => {
                const g = parseInt(dishGuests, 10) || 4;
                const amt = splitOf || 540;
                navigate(`/mobile/split-bill-payment/${tableNo}?amount=${amt}&guests=${g}`);
              }}
            />

            {/* Add new split */}
            <div className="flex justify-end">
              <button
                type="button"
                className="font-sansation font-bold text-[16px] bg-transparent border-0"
                style={{ color: "#F15A29" }}
              >
                + Add New Split
              </button>
            </div>
          </div>

          {/* Continue */}
          <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full bg-white px-3 py-4 z-50 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
            <button
              type="button"
              onClick={() => navigate(`/mobile/payment/${tableNo}`)}
              className="w-full rounded-[6px] py-3.5 font-sansation font-bold text-[14px] tracking-[-0.28px] uppercase text-white border-0"
              style={{ backgroundColor: "#F15A29" }}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SplitBill;
